import { render, staticRenderFns } from "./DashboardHero12MonthsDataUsage.vue?vue&type=template&id=1585b4c9&"
import script from "./DashboardHero12MonthsDataUsage.vue?vue&type=script&lang=js&"
export * from "./DashboardHero12MonthsDataUsage.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHero12MonthsDataUsage.vue?vue&type=style&index=0&id=1585b4c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports